<cx-searchbox
  [quickOrder]="true"
  [searchValueClear]="clearSearchValue"
  (selectedProductEvent)="onProductSelected($event)"
  [config]="QUICKORDER_SEARCH_BOX_CONFIG">
</cx-searchbox>

@if (quickOrderDetail && !productInfo?.flu) {
  <div class="mt-2 mb-4 custom-quick-order">
    <app-contracts-partial
      [contractFromCartApi]="contractFromCartApi"
      [conditions]="productInfo?.conditions"
      [selectedChannel]="selectedChannel"
      [hasMatchingContract]="hasMatchingContract"
      [showPriceGroup]="showPriceGroup"
      [priceGroupToShow]="priceGroupToShow"
      (selectedContract)="onSelectedContract($event)"
      (selectPriceGroup)="onSelectPriceGroup($event)"
    />

    <!-- Price / Unit -->
    <div class="unit-calc">
      <div class="d-flex justify-content-around flex-wrap-reverse w-100 mb-4 mt-4">
        <div class="price-details">
          <div class="mb-2 text-fixed-legal-copy color-grey-dark font-weight-bold">
            {{ productInfo.actualPotency ? ('plp.unitPrice' | cxTranslate) : ('plp.yourPrice' | cxTranslate) }}
            {{ ProductUtils.getUnitTranslation(selectedChannel) }}
          </div>

          <div class="c-heading c-heading-h3">
            @if (displayLocalPriceAsLocalCurrency() && !checkIfUnavailableToOrder()) {
              <span>{{ productInfo?.price?.value | localCurrency }}</span>
            }

            @if (showContract && contractSelected && priceToShow && selectedChannel === PriceChannel.PUBLIC) {
              <span>{{ priceToShow | localCurrency }}</span>
            }
          </div>
        </div>

        @if (!productInfo?.discontinued && productInfo?.available) {
          <div class="units mb-3">
            <label class="mb-2 text-center text-fixed-legal-copy font-weight-bold color-grey-dark" for="{{ 'prodQuantity' + productInfo.code + 'q' }}">
              {{ 'plp.units' | cxTranslate }}
              {{ ProductUtils.getUnitTranslation(selectedChannel) }}
            </label>
            <div class="d-flex justify-content-center align-items-center">
              <span id="{{ 'unitMinus' + productInfo?.code + 'q' }}" class="d-none"></span>
              <span id="{{ 'unitMinusDisable' + productInfo?.code + 'q' }}" class="d-none"></span>
              <span id="{{ 'unitPlus' + productInfo?.code + 'q' }}" class="d-none"></span>
              <span id="{{ 'unitPlusDisable' + productInfo?.code + 'q' }}" class="d-none"></span>

              <button
                class="c-count-change-btn disabled"
                id="{{ 'minusIcon' + productInfo.code + 'q' }}"
                (click)="performQuantityComputation(2)">
                <em class="fa fa-minus" aria-hidden="true"></em>
              </button>
              <input
                [class]="{
                    'custom-quick-order__quantityPublic': selectedChannel === PriceChannel.PUBLIC,
                    'custom-quick-order__quantityPrivate': selectedChannel === PriceChannel.PRIVATE
                  }"
                autoSizeInput
                [includeBorders]="true"
                type="number"
                class="prod-quantity text-center"
                value="{{ conditionsForCartonsLogicMeet ? productInfo.numberOfUnitsPerCarton : '1' }}"
                (blur)="performQuantityComputation(null)"
                id="{{ 'prodQuantity' + productInfo.code + 'q' }}"
                min="1"
                max="{{ProductUtils.getMaximumQuantity(selectedChannel)}}"/>
              <button
                class="c-count-change-btn"
                id="{{ 'plusIcon' + productInfo.code + 'q' }}"
                (click)="performQuantityComputation(1)">
                <em class="fa fa-plus" aria-hidden="true"></em>
              </button>
            </div>

            @if (conditionsForCartonsLogicMeet) {
            <div class="w-100 mt-1 d-flex justify-content-center text-center" id="{{'noOfCartons' + productInfo?.code + 'q'}}">
              <span class="red">min 1 cx embarque</span>
            </div>
            }

          </div>
        }
      </div>
      <!-- Private Button -->
      @if (checkIfProductCanBeAddedToTheCartWithPrivate()) {
        <button
          type="button"
          class="c-button c-button--primary quickorder-button"
          [ngbPopover]="popTitleSuccess"
          placement="bottom"
          triggers="manual"
          #p2="ngbPopover"
          popoverClass="savesuccess-msg"
          [closeDelay]="500"
          (click)="addToCart(productInfo?.code + 'q', productInfo?.code)"
          id="prod-{{ productInfo?.code }}">
          <ng-template #popTitleSuccess>
            <div class="cart-value-added">
              <img src="icons/confirmation-positive-green.png" class="positive-green-icon" alt="suc" />
              <span class="confirmation-itemsadded">{{ itemAddedQuantity }} {{ 'addToCartItems.addEntrySuccess' | cxTranslate }}</span>
            </div>
          </ng-template>
          @if (isReserveNowButton()) {
            <em class="fa fa-calendar" aria-hidden="true"></em>
          }
          {{ buttonName }}
        </button>
      }
      <!-- Dynamic Add to cart Button -->
      @if (checkIfProductCanBeAddedToTheCart()) {
        <button
          type="button"
          class="c-button c-button--primary quickorder-button"
          [ngbPopover]="popTitleSuccess"
          placement="bottom"
          triggers="manual"
          #p2="ngbPopover"
          popoverClass="savesuccess-msg"
          [closeDelay]="500"
          (click)="openModal(productInfo?.code + 'q', productInfo?.code, contractSelected, addToCartNotice)"
          id="prod-{{ productInfo?.code }}"
          [disabled]="!enableBtn">
          <ng-template #popTitleSuccess>
            <div class="cart-value-added">
              <img src="icons/confirmation-positive-green.png" class="positive-green-icon" alt="suc" />
              <span class="confirmation-itemsadded">{{ itemAddedQuantity }} {{ 'addToCartItems.addEntrySuccess' | cxTranslate }}</span>
            </div>
          </ng-template>

          @if (isReserveNowButton()) {
            <em class="fa fa-calendar" aria-hidden="true"></em>
          }
          {{ buttonName }}
        </button>
      }
      <!-- Contract modal -->
      <ng-template #addToCartNotice>
        <section
          class="header-modal checkout-modal modal-selector modal-with-select">
          <section class="modal-dialog d-flex">
            <div class="modal-content">
              <div class="close">
                <em class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mr-3 mt-4" (click)="modal.dismissAll()"></em>
              </div>
              <section class="modal-body px-4">
                Ao adicionar este produto ao carrinho usando o contrato
                @if (productInfo?.conditions?.length === 1) {
                  <span>{{ productInfo?.conditions[0]?.contractId }} ({{ productInfo?.conditions[0]?.contractName }})</span>
                }

                @if (productInfo?.conditions?.length > 1) {
                  <span>{{ contractSelectedId }} ({{ contractSelected?.contractName }})</span>
                },
                você pode continuar adicionando produtos que estão contemplados no mesmo contrato.
                Se deseja adicionar produtos usando um contrato diferente, limpe o carrinho atual
                e selecione o produto do contrato desejado
              </section>
              <section class="modal-footer justify-content-start">
                <button
                  type="button"
                  class="c-button c-button--secondary ml-3"
                  (click)="modal.dismissAll()">
                  {{ 'account.cancel' | cxTranslate }}
                </button>
                <button
                  (click)="addToCart(productInfo?.code + 'q', productInfo?.code, contractSelected); modal.dismissAll();"
                  class="c-button c-button--primary ml-3">
                  {{ 'account.continue' | cxTranslate }}
                </button>
              </section>
            </div>
          </section>
        </section>
      </ng-template>

      @if (!productInfo?.discontinued && productInfo?.available) {
        <section>
          @if (productInfo.sapAllocation) {
            <section>
              <strong class="prod-allocation">{{'plp.productAllocation' | cxTranslate }}</strong>
              <p class="allocation-p">{{ 'plp.allocationDetails' | cxTranslate }}</p>
            </section>
          }
        </section>
      }
    </div>

    @if (productInfo?.discontinued || !productInfo?.available) {
      <section>
        @if (productInfo?.discontinued && productInfo?.available) {
          <section>
            <p class="product-discontinued-txt1">{{ 'plp.discontinued' | cxTranslate }}</p>
          </section>
        }

        @if (productInfo?.discontinued && !productInfo?.available) {
          <section>
            <p class="product-discontinued-txt1">{{ 'plp.discontinued' | cxTranslate }}</p>
          </section>
        }

        @if (!productInfo.discontinued && !productInfo.available) {
          <section class="m0 left-align">
            @if (productInfo.availabilityText) {
              <strong class="prod-allocation class-avail">{{ productInfo.availabilityText }}</strong>
            } @else {
              <strong class="prod-allocation class-avail">{{ 'plp.noavailabilityText' | cxTranslate }}</strong>
            }
          </section>
        }
      </section>
    }

    @if (productInfo.flu && productInfo.available && !productInfo.discontinued) {
      <div>
        <button type="button" class="c-button c-button--secondary w-100" (click)="navToReservenow()">

          @if (isReserveNowButton()) {
            <em class="fa fa-calendar" aria-hidden="true"></em>
          }

          {{ 'plp.reserve' | cxTranslate }}
        </button>
      </div>
    }

    @if (checkIfUnavailableToOrder()) {
      <button type="button" class="c-button c-button--primary w-100" disabled>{{ 'plp.unavailableToOrder' | cxTranslate }}</button>
    }
  </div>
}
